import { createAction, props } from '@ngrx/store';
import { ISystemInfo } from 'app/core/services/api-client';

export const loadSystemInfo = createAction(
  '[Startpage SystemInfo - Effect] Load System Info'
);

export const loadSystemInfoSuccess = createAction(
  '[Startpage SystemInfo] Load System Info Success',
  props<{ systemInfo: ISystemInfo }>()
);

export const loadSystemInfoError = createAction(
  '[Startpage SystemInfo] Load System Info Error'
);
